/*
  BTK Buying & Planning Style Drawer - SHARED engine.
  Single source of truth for the slide-over drawer used on BOTH the
  kitchen-units listing page and the planner. Each host page supplies its
  own #bkuBsDrawer DOM + CSS; this script drives it. The planner registers
  window.__btkBuyingStyleHooks to apply switches in-place (no reload);
  pages without hooks fall back to a filtered page reload.
  Open it from anywhere via window.bkuOpenStyleDrawer().
*/
(function() {
  /* Guard - the drawer JS is a self-running IIFE; if a page already
     loaded an instance of this script (e.g. the inline listing-page
     copy was loaded first) skip the duplicate to avoid double-binding
     the close/backdrop click listeners. */
  if (window.__btkBuyingStyleDrawerInit) return;
  window.__btkBuyingStyleDrawerInit = true;

  var drawer    = document.getElementById('bkuBsDrawer');
  var backdrop  = document.getElementById('bkuBsBackdrop');
  var closeBtn  = document.getElementById('bkuBsClose');
  var cardsEl   = document.getElementById('bkuBsCards');

  function prettyHandle(h) {
    if (!h) return '';
    return String(h).replace(/-/g, ' ').replace(/\b\w/g, function(l) { return l.toUpperCase(); });
  }

  // Names reach here from the URL, sessionStorage and cart attributes, so they
  // are escaped before going into markup.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getCarcaseUrl(handle) {
    if (!window.__ksd || !window.__ksd.carcaseMap) return '';
    var ch = (handle || 'white').toLowerCase().replace(/[\s-]/g, '');
    var keys = Object.keys(window.__ksd.carcaseMap);
    var fk = keys.find(function(k) {
      var kn = k.toLowerCase().replace(/[\s-]/g, '');
      return kn.includes(ch) && !kn.includes('th') && !kn.includes('handleless');
    }) || keys.find(function(k) {
      return k.toLowerCase().replace(/[\s-]/g, '').includes(ch);
    });
    return fk ? window.__ksd.carcaseMap[fk].img : '';
  }

  function getDoorUrl(style, colour) {
    if (!window.__ksd || !window.__ksd.doorMap) return '';
    return window.__ksd.doorMap[style + ':' + colour] || '';
  }

  function openDrawer() {
    buildDrawerCards();
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  window.bkuOpenStyleDrawer = openDrawer;

  function closeDrawer() {
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  /* Notify any planner / sidebar listeners that the active style
     changed - they redraw their mini-bars without a page reload. */
  function emitChanged(ctx) {
    try {
      document.dispatchEvent(new CustomEvent('btk:style-changed', { detail: ctx || null }));
    } catch (_) {}
  }

  function switchToStyle(newCtx) {
    var currentCtx = null;
    try { currentCtx = JSON.parse(sessionStorage.getItem('btk_kitchen_context') || 'null'); } catch(e) {}
    var alts = [];
    try { alts = JSON.parse(sessionStorage.getItem('btk_comparison_styles') || '[]'); } catch(e) {}

    if (currentCtx && currentCtx.style) {
      var alreadyIn = alts.some(function(a) {
        return a && a.style === currentCtx.style && a.colour === currentCtx.colour;
      });
      if (!alreadyIn) alts.push(currentCtx);
    }
    alts = alts.filter(function(a) {
      return !(a && a.style === newCtx.style && a.colour === newCtx.colour);
    });

    sessionStorage.setItem('btk_kitchen_context', JSON.stringify(newCtx));
    sessionStorage.setItem('btk_comparison_styles', JSON.stringify(alts));

    try {
      var slots = JSON.parse(sessionStorage.getItem('btk_style_slots') || '[]');
      var newKey = newCtx.style + ':' + newCtx.colour;
      if (!slots.some(function(k) { return k === newKey; })) {
        var emptyIdx = slots.indexOf('');
        if (emptyIdx > -1) slots[emptyIdx] = newKey;
        else slots.push(newKey);
        while (slots.length < 3) slots.push('');
        sessionStorage.setItem('btk_style_slots', JSON.stringify(slots));
      }
    } catch(e) {}

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        kitchen_style:          newCtx.style,
        kitchen_style_name:     newCtx.styleName || '',
        kitchen_colour:         newCtx.colour,
        kitchen_carcase_colour: newCtx.carcase,
        // Mirror the alternates to cart so the full set survives across tabs.
        kitchen_comparison_styles: alts.length ? JSON.stringify(alts) : ''
      }})
    }).then(function() {
      closeDrawer();
      emitChanged(newCtx);
      /* Planner-aware path - if a host has registered a switch hook
         (the planner page does this on init) call it so the change
         is applied in-place and we DON'T reload. The hook returns
         truthy to claim the switch. */
      var hooks = window.__btkBuyingStyleHooks;
      if (hooks && typeof hooks.onSwitchToStyle === 'function') {
        try {
          if (hooks.onSwitchToStyle(newCtx)) return;
        } catch (_) {}
      }
      /* Default behaviour (listing page): reload with the new style
         params so the filter recalculates against the catalogue. */
      var url = new URL(window.location.href);
      url.searchParams.set('style', newCtx.style);
      url.searchParams.set('colour', newCtx.colour);
      url.searchParams.set('carcase', newCtx.carcase || 'white');
      /* The friendly params above are context only - this is the param that
         actually filters the collection. Without it the reload keeps the
         PREVIOUS style's filter on the URL, so the server pages the old
         style's products while the grid's own gate shows the new style's:
         a correct-but-near-empty grid. */
      if (url.pathname.indexOf('/collections/') === 0) {
        url.searchParams.set('filter.p.m.custom.kitchen_style_handle', newCtx.style);
        url.searchParams.append('filter.p.m.custom.kitchen_style_handle', 'all');   // ...OR all: shared (no-door) products are in every style (PR #171).
      }
      window.location.href = url.toString();
    });
  }

  function buildCardEl(ctxData, isActive) {
    var name       = (window.__ksd && window.__ksd.nameMap && window.__ksd.nameMap[ctxData.style]) || ctxData.styleName || prettyHandle(ctxData.style);
    var nameParts  = name.trim().split(' ');
    var nameFirst  = nameParts[0] || '';
    var nameRest   = nameParts.slice(1).join(' ');
    var doorUrl    = getDoorUrl(ctxData.style, ctxData.colour);
    var carcaseUrl = getCarcaseUrl(ctxData.carcase);
    var doorColour = window.__ksd && window.__ksd.doorColourMap && window.__ksd.doorColourMap[ctxData.colour] || '';
    var carcaseSwatch = window.__ksd && window.__ksd.carcaseSwatchMap && window.__ksd.carcaseSwatchMap[ctxData.carcase] || '';

    var card = document.createElement('div');
    card.className = 'bku-bs-card' + (isActive ? ' bku-bs-card--active' : ' bku-bs-card--alt');

    if (doorColour) {
      card.style.background = doorColour;
      var r = parseInt(doorColour.slice(1,3), 16);
      var g = parseInt(doorColour.slice(3,5), 16);
      var b = parseInt(doorColour.slice(5,7), 16);
      var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      card.style.color = lum > 0.5 ? '#111' : '#fff';
    }

    var top = document.createElement('div');
    top.className = 'bku-bs-card__top';
    var info = document.createElement('div');
    info.className = 'bku-bs-card__info';

    var status = document.createElement('span');
    status.className = 'bku-bs-card__status';
    status.textContent = isActive ? 'Active Style' : 'Switch to';
    if (doorColour) {
      var lum2 = (0.299 * parseInt(doorColour.slice(1,3),16) + 0.587 * parseInt(doorColour.slice(3,5),16) + 0.114 * parseInt(doorColour.slice(5,7),16)) / 255;
      status.style.color = lum2 > 0.5 ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.7)';
    }
    info.appendChild(status);

    var nameEl = document.createElement('div');
    nameEl.className = 'bku-bs-card__name';
    nameEl.innerHTML = '<span style="font-weight:800;">' + esc(nameFirst) + '</span>' +
      (nameRest ? '<span style="font-weight:300;"> ' + esc(nameRest) + '</span>' : '');
    if (doorColour) {
      var lum3 = (0.299 * parseInt(doorColour.slice(1,3),16) + 0.587 * parseInt(doorColour.slice(3,5),16) + 0.114 * parseInt(doorColour.slice(5,7),16)) / 255;
      nameEl.style.color = lum3 > 0.5 ? '#111' : '#fff';
    }
    info.appendChild(nameEl);

    var chips = document.createElement('div');
    chips.className = 'bku-bs-card__chips';

    var doorChip = document.createElement('div');
    doorChip.className = 'bku-bs-card__chip';
    doorChip.style.background = '#fff';
    doorChip.innerHTML =
      '<span class="bku-bs-chip__dot" style="background:' + doorColour + ';"></span>' +
      '<div class="bku-bs-chip__text">' +
        '<span class="bku-bs-chip__label">Door</span>' +
        '<span class="bku-bs-chip__value">' + esc(ctxData.colourName || prettyHandle(ctxData.colour)) + '</span>' +
      '</div>';
    chips.appendChild(doorChip);

    var carcaseChip = document.createElement('div');
    carcaseChip.className = 'bku-bs-card__chip';
    carcaseChip.style.background = '#fff';
    carcaseChip.innerHTML =
      '<span class="bku-bs-chip__dot" style="' + (carcaseSwatch ? 'background-image:url(' + carcaseSwatch + ');background-size:cover;' : '') + '"></span>' +
      '<div class="bku-bs-chip__text">' +
        '<span class="bku-bs-chip__label">Carcase</span>' +
        '<span class="bku-bs-chip__value">' + esc(prettyHandle(ctxData.carcase || 'white')) + '</span>' +
      '</div>';
    chips.appendChild(carcaseChip);

    info.appendChild(chips);

    var removeLink = document.createElement('a');
    removeLink.className = 'bku-bs-card__switch-link';
    removeLink.href = 'javascript:void(0)';
    removeLink.textContent = 'Remove';
    (function(data, el, active) {
      el.addEventListener('click', function(e) {
        e.stopPropagation();
        try {
          var slots = JSON.parse(sessionStorage.getItem('btk_style_slots') || '[]');
          var key = data.style + ':' + data.colour;
          var ki = slots.indexOf(key);
          if (ki > -1) slots[ki] = '';
          sessionStorage.setItem('btk_style_slots', JSON.stringify(slots));
        } catch(err) {}

        if (active) {
          var currentAlts = [];
          try { currentAlts = JSON.parse(sessionStorage.getItem('btk_comparison_styles') || '[]'); } catch(err) {}
          if (currentAlts.length) {
            var promoted = currentAlts.shift();
            sessionStorage.setItem('btk_kitchen_context', JSON.stringify(promoted));
            sessionStorage.setItem('btk_comparison_styles', JSON.stringify(currentAlts));
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: {
                kitchen_style:          promoted.style,
                kitchen_style_name:     promoted.styleName || '',
                kitchen_colour:         promoted.colour,
                kitchen_carcase_colour: promoted.carcase,
                kitchen_comparison_styles: currentAlts.length ? JSON.stringify(currentAlts) : ''
              }})
            }).then(function() {
              emitChanged(promoted);
              var hooks = window.__btkBuyingStyleHooks;
              if (hooks && typeof hooks.onSwitchToStyle === 'function') {
                try { if (hooks.onSwitchToStyle(promoted)) { buildDrawerCards(); return; } } catch (_) {}
              }
              var url = new URL(window.location.href);
              url.searchParams.set('style', promoted.style);
              url.searchParams.set('colour', promoted.colour);
              url.searchParams.set('carcase', promoted.carcase || 'white');
              /* Keep the real collection filter in step with the promoted
                 style - see the note on the switch path above. */
              if (url.pathname.indexOf('/collections/') === 0) {
                url.searchParams.set('filter.p.m.custom.kitchen_style_handle', promoted.style);
                url.searchParams.append('filter.p.m.custom.kitchen_style_handle', 'all');   // ...OR all: shared (no-door) products are in every style (PR #171).
              }
              window.location.href = url.toString();
            });
          } else {
            sessionStorage.removeItem('btk_kitchen_context');
            sessionStorage.removeItem('btk_comparison_styles');
            sessionStorage.removeItem('btk_style_slots');
            sessionStorage.setItem('btk_context_skip_cart_sync', '1');
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: {
                kitchen_style: '', kitchen_style_name: '',
                kitchen_colour: '', kitchen_carcase_colour: '',
                kitchen_comparison_styles: ''
              }})
            }).then(function() {
              emitChanged(null);
              var hooks = window.__btkBuyingStyleHooks;
              if (hooks && typeof hooks.onActiveCleared === 'function') {
                try { if (hooks.onActiveCleared()) { buildDrawerCards(); return; } } catch (_) {}
              }
              window.location.href = window.location.pathname;
            });
          }
        } else {
          var currentAlts2 = [];
          try { currentAlts2 = JSON.parse(sessionStorage.getItem('btk_comparison_styles') || '[]'); } catch(err) {}
          currentAlts2 = currentAlts2.filter(function(a) {
            return !(a && a.style === data.style && a.colour === data.colour);
          });
          sessionStorage.setItem('btk_comparison_styles', JSON.stringify(currentAlts2));
          // Mirror to cart so the removal survives across tabs.
          try {
            fetch('/cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { kitchen_comparison_styles: currentAlts2.length ? JSON.stringify(currentAlts2) : '' } })
            });
          } catch (e) {}
          buildDrawerCards();
        }
      });
    })(ctxData, removeLink, isActive);
    info.appendChild(removeLink);

    top.appendChild(info);

    var imgs = document.createElement('div');
    imgs.className = 'bku-bs-card__images';
    imgs.style.background = '#fff';
    if (carcaseUrl) {
      var ci = document.createElement('img');
      ci.className = 'bku-bs-card__img bku-bs-card__img--carcase';
      ci.src = carcaseUrl; ci.alt = '';
      imgs.appendChild(ci);
    }
    if (doorUrl) {
      var di = document.createElement('img');
      di.className = 'bku-bs-card__img bku-bs-card__img--door';
      di.src = doorUrl; di.alt = '';
      imgs.appendChild(di);
    }
    top.appendChild(imgs);

    if (isActive) {
      var tick = document.createElement('div');
      tick.className = 'bku-bs-card__tick';
      tick.textContent = '✓';
      card.appendChild(tick);
    }

    card.appendChild(top);

    if (!isActive) {
      card.addEventListener('click', function() { switchToStyle(ctxData); });
    }

    return card;
  }

  function buildDrawerCards() {
    if (!cardsEl) return;
    cardsEl.innerHTML = '';

    var ctx = null;
    try { ctx = JSON.parse(sessionStorage.getItem('btk_kitchen_context') || 'null'); } catch(e) {}
    var alts = [];
    try { alts = JSON.parse(sessionStorage.getItem('btk_comparison_styles') || '[]'); } catch(e) {}

    var styleSlots = [];
    try { styleSlots = JSON.parse(sessionStorage.getItem('btk_style_slots') || '[]'); } catch(e) {}

    /* Init when slots are missing OR fully empty (["", "", ""]).
       The fully-empty case happens on a fresh planner load: the
       orchestrator's reconcile runs before btk-kitchen-context's
       async cart sync has populated ctx, so it writes a zero-key
       array. Without this check the drawer would render three
       placeholders even though we have an active ctx. */
    var hasAnyValid = styleSlots.some(function(k) { return !!k; });
    if (!hasAnyValid) {
      var initial = [ctx, alts[0] || null, alts[1] || null];
      styleSlots = initial.map(function(s) { return s && s.style ? (s.style + ':' + s.colour) : ''; });
      try { sessionStorage.setItem('btk_style_slots', JSON.stringify(styleSlots)); } catch(e) {}
    }

    var allStyles = [];
    if (ctx && ctx.style) allStyles.push(ctx);
    alts.forEach(function(a) { if (a && a.style) allStyles.push(a); });

    var slotsToRender = styleSlots.slice(0, 3);
    while (slotsToRender.length < 3) slotsToRender.push('');

    slotsToRender.forEach(function(key, i) {
      var slot = null;
      if (key) {
        var parts = key.split(':');
        slot = allStyles.find(function(s) { return s.style === parts[0] && s.colour === parts[1]; }) || null;
      }

      if (slot && slot.style) {
        var isActive = ctx && slot.style === ctx.style && slot.colour === ctx.colour;
        cardsEl.appendChild(buildCardEl(slot, isActive));
      } else {
        /* If the host page (the planner) has registered a hook to
           handle "Add Buying Style" in-place, render a button that
           calls it. Otherwise keep the original navigation to
           /pages/kitchens (the listing page builds new styles
           via the storefront kitchen-style cards). */
        var hooks = window.__btkBuyingStyleHooks;
        var hasAddHook = hooks && typeof hooks.onAddBuyingStyleRequested === 'function';
        var ph;
        if (hasAddHook) {
          ph = document.createElement('button');
          ph.type = 'button';
          ph.className = 'bku-bs-card--placeholder';
          ph.innerHTML =
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>' +
            '<span>Add Buying Style ' + (i + 1) + '</span>';
          ph.addEventListener('click', function() {
            closeDrawer();
            try { hooks.onAddBuyingStyleRequested(); } catch (_) {}
          });
        } else {
          ph = document.createElement('a');
          ph.className = 'bku-bs-card--placeholder';
          ph.href = '/pages/kitchens';
          ph.innerHTML =
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>' +
            '<span>Add Buying Style ' + (i + 1) + '</span>';
          ph.addEventListener('click', function() { closeDrawer(); });
        }
        cardsEl.appendChild(ph);
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });
})();
